import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-placement-cell',
  templateUrl: './placement-cell.component.html',
  styleUrls: ['./placement-cell.component.scss']
})
export class PlacementCellComponent implements OnInit {
  pdfSrc:string= '/assets/pdf/NAAC/Team Report.pdf';
  constructor() { }

  ngOnInit(): void {
  }

}
